import { IconContent } from '../icon.interface';

export const severity: IconContent = {
    sm: '<path d="M2.2666 13.4333V12.9H13.7333V13.4333H2.2666ZM3.0666 11.5871V8.36665H3.99994V11.5871H3.0666ZM6.03577 11.5871V5.16665H6.9691V11.5871H6.03577ZM9.01794 11.5871V7.16665H9.95127V11.5871H9.01794ZM11.9999 11.5871V3.56665H12.9333V11.5871H11.9999Z"/>'
};
